export class NewsTagService {
  constructor($resource, AuthService, ApiService, $cookies) {
    "ngInject";

    this.$cookies = $cookies;
    this.$resource = $resource;
    this.apiService = ApiService;
    this.authService = AuthService;
    //url
    this.newsTagUrl = this.apiService.getResourceUrl("/news/tags");
    this.createNewsTagUrl = this.apiService.getResourceUrl("/news/tag");
    this.newsTagWithIdUrl = this.apiService.getResourceUrl("/news/tags/:id");

    //resource
    this.individualResource = this.$resource(this.newsTagUrl, null, {
      getDetails: { method: "get" },
    });

    this.individualResourceWithId = this.$resource(
      this.newsTagWithIdUrl,
      null,
      {
        getDetails: { method: "get" },
        update: { method: "put" },
        delete: { method: "delete" },
      }
    );

    //create news tag
    this.createNewsTagResource = this.$resource(this.createNewsTagUrl, null, {
      update: { method: "post" },
    });
  }

  getNewsTagList() {
    const promise = this.individualResource.getDetails().$promise;
    return promise
      .then(({ details }) => details.newsTagsList)
      .catch((error) => {
        console.log("error", error);
      });
  }

  updateNewsTag(details, type) {
    const _promise =
      type === "add"
        ? this.createNewsTagResource.update(details)
        : this.individualResourceWithId.update(
            { id: details.newsTagId },
            { name: details.name }
          );
    const promise = _promise.$promise;
    return promise.then((response) => response);
  }

  getNewsTagEditDetails(id) {
    const promise = this.individualResourceWithId.getDetails({ id }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        console.log("error", error);
      });
  }

  deleteNewsTag(id) {
    const promise = this.individualResourceWithId.delete({ id }).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        console.log("error", error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/news-tag/news-tag.service.js